import styled from 'styled-components';

export const Hint = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.gray[700]};
`;

export const SectionsStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: clamp(16px, 3vw, 24px);
    min-width: 0;
`;

export const SettingsForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const ParameterList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const ParameterItem = styled.li`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
    padding: 0 0 20px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray[200]};

    &:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }
`;

export const ParameterForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ParameterDescription = styled.label`
    font-weight: 600;
    line-height: 1.4;
    color: ${({ theme }) => theme.colors.gray[900]};
`;

export const ParameterKey = styled.code`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.gray[700]};
`;

export const ParameterControls = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
`;

export const ParameterInput = styled.input`
    width: ${({ $wide }) => ($wide ? 'min(100%, 420px)' : '160px')};
    max-width: 100%;
    padding: 10px;
    border: 1px solid ${({ theme, $hasError }) =>
        $hasError ? theme.colors.danger.main : theme.colors.gray[200]};
    border-radius: 4px;
    background: #fff;

    &:focus {
        border-color: ${({ theme, $hasError }) =>
            $hasError ? theme.colors.danger.main : theme.colors.primary.main};
        outline: none;
    }

    &:disabled {
        background: ${({ theme }) => theme.colors.gray[100]};
        color: ${({ theme }) => theme.colors.gray[700]};
    }
`;

export const BooleanControl = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray[900]};

    input {
        width: 16px;
        height: 16px;
    }
`;

export const InlineStatus = styled.span`
    font-size: 13px;
    color: ${({ theme }) => theme.colors.success?.main || '#15803d'};
`;

export const Previews = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
    gap: 16px;
`;

export const PreviewBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const PreviewLabel = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.gray[700]};
    text-transform: uppercase;
    letter-spacing: 0.02em;
`;

export const PreviewFrame = styled.div`
    width: 100%;
    aspect-ratio: 640 / 225;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8fafc;
    border: 1px solid ${({ theme, $hasError }) =>
        $hasError ? theme.colors.danger.main : '#e2e8f0'};
    border-radius: 12px;
    overflow: hidden;
    padding: 12px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;

export const FileInput = styled.input`
    padding: 10px;
    border: 1px solid ${({ theme, $hasError }) =>
        $hasError ? theme.colors.danger.main : theme.colors.gray[200]};
    border-radius: 4px;
    background: #fff;

    &:focus {
        border-color: ${({ theme, $hasError }) =>
            $hasError ? theme.colors.danger.main : theme.colors.primary.main};
        outline: none;
    }
`;

export const FieldError = styled.span`
    color: ${({ theme }) => theme.colors.danger.main};
    font-size: 12px;
    line-height: 1.4;
    white-space: pre-line;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
`;
